module.exports = __webpack_public_path__ + "static/media/pin.25826fa0.jpg";